import { picklistApi } from 'api';
import {
  generatePicklistPdf,
  generateBatchPicklistPdf,
} from 'utils/pdfGenerators';
import { PICKLIST_TYPES } from 'constants/admin/warehouse';
import { PRINT_PAGE_SIZE_STORAGE_KEYS } from 'constants/printPageSize';
import { getPreferredPrintPageSize } from 'utils/printPageSize';
import paths from 'routes/paths';

// The app path is /:tenant/:warehouse/... — same derivation as BaseApi.
const getBatchPickingUrl = picklistId => {
  const [tenant, warehouse] = window.location.pathname
    .split('/')
    .filter(Boolean);
  if (!tenant || !warehouse) return null;
  return `${window.location.origin}${paths.picklists.livePicking(
    tenant,
    warehouse,
    picklistId,
  )}`;
};

/**
 * Print the picklist PDF, branching on the picklist's type snapshot.
 *
 * - barcode mode: product-batch rows (existing template)
 * - batch_code mode: one row per shipment with cart partition numbers
 *
 * Pass `picklistType` when the caller already has it (list row, detail data)
 * to avoid an extra request; otherwise it is fetched from the detail API.
 *
 * `pageSize` is one of PRINT_PAGE_SIZES and defaults to the last size the
 * user printed a picklist with.
 *
 * `printContext` ({ tenantName, warehouseName }) is printed under the title.
 */
export const printPicklistPdf = async (
  picklistId,
  picklistCode,
  picklistType = null,
  pageSize = getPreferredPrintPageSize(PRINT_PAGE_SIZE_STORAGE_KEYS.PICKLIST),
  printContext = {},
) => {
  let type = picklistType;

  if (!type) {
    const picklist = await picklistApi.getById(picklistId);
    type = picklist?.picklist_type;
  }

  if (type === PICKLIST_TYPES.BATCH_CODE) {
    const response = await picklistApi.getShipmentPartitions(picklistId);
    generateBatchPicklistPdf(
      response,
      picklistCode,
      getBatchPickingUrl(picklistId),
      pageSize,
      printContext,
    );
  } else {
    const response = await picklistApi.getProductBatchesOfPicklist(picklistId);
    generatePicklistPdf(response.results, picklistCode, pageSize, printContext);
  }
};
